import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logout-finished',
  templateUrl: './logout-finished.component.html',
  styleUrls: ['./logout-finished.component.scss']
})
export class LogoutFinishedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
